import r from "./restArguments.js";
import t from "./unzip.js";
var m = r(t);
export { m as default };